<template>
  <div>
    <div>
      <Title v-if="!isAdmin" :showMinister="true" :showService="true" />
    </div>

    <div class="breacrumb">
      <Breadcrumb :links="breadCrumbData" />
    </div>

    <div class="carrusel">
      <Carrusel />
    </div>
    <div class="container">
      <Button />
    </div>

    <div v-if="permiso">
      <Main
        :userPermissions="userPermissions"
        :userPermission="userPermission"
      />
    </div>

    <div v-else>
      <NotPermision :contenido="contenido" />
    </div>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Carrusel from "../../../components/private/Carrusel.vue";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import NotPermision from "@/components/private/TextNotPermisionPrueba.vue";
import Main from "./else/Main.vue";
import Button from "./else/Button.vue";
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: {
    Title,
    Carrusel,
    Breadcrumb,
    NotPermision,
    Main,
    Button,
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  data() {
    return {
      permiso: false,
      breadCrumbData: null,
      contenido: null,
      user: false,
      userPermissions: true,
      userPermission: true,
    };
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Presentación del Servicio - Resumen Ejecutivo",
          routeName: "servicios",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 2) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 5 ||
        relacionUs.rolId === 4
      ) {
        this.permiso = true;
      }
    },
    obtenerContenido: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "presentacion_servicio",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        if (res.data) {
          this.contenido = res.data.info.content;
        }
        console.log(res.data);
      } catch (error) {
        console.log(error);
      }
    },

    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const data = JSON.parse(localStorage.getItem("user"));
        const relacionUs = data.servicios.find(
          (s) => s.id === parseInt(this.$route.params.idServicio)
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);

        //funcionario Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Jefe de Servicio BGI Borrador
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        }

        //Jefe de Servicio BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        }

        //Funcionario
        if (relacionUs.rolId === 5) {
          this.userPermission = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerContenido();
    this.obtenerRevision();
  },
};
</script>
